export default "__VITE_ASSET__l8mR1oW8__"